const typographyFormParamEquipModel = {
  true: 'Cadastro de Novo Tipo de Equipamento',
  false: 'Editar Tipo de Equipamento'
};

export default typographyFormParamEquipModel;
